import React, { Fragment } from 'react';
import { isNull } from 'lodash';
import { useDispatch } from 'react-redux';
import SearchBox from '../../../../components/outline/SearchBox';
import BaseForm from '../../../../components/form/BaseForm';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { addAllItemToSelectList } from '../../../../lib/common';
import Select from '../../../../components/input/Select/Select';
import Input from '../../../../components/input/Input/Input';
import RadioGroup from '../../../../components/input/RadioGroup/RadioGroup';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  PLACEHOLDER_TEXT_WIDGET_EXPOSURE_PERIOD_DATE,
  WIDGET_EXPOSURE_SEARCH_TYPE_SELECT_LIST,
  WIDGET_EXPOSURE_TYPE,
  WIDGET_LAYOUT_TYPE_SELECT_LIST,
  WIDGET_SEARCH_KEYWORD_TYPE,
  WIDGET_SEARCH_KEYWORD_TYPE_SELECT_LIST,
  WIDGET_TYPE_SELECT_LIST,
} from '../../../../constants/service/app/widgetConstants';
import { widgetActions } from '../../../../store/modules/widget';
import { ValueOf } from '../../../../types/common/utils';
import { WidgetAllListRequest, WidgetAllListSearchData } from '../WidgetAllListWrap/WidgetAllListWrap';
import './WidgetAllListSearchBox.scss';

interface WidgetAllListSearchBoxProps {
  onClear: () => void;
  searchOption: WidgetAllListSearchData;
  getList: (payload: WidgetAllListRequest) => void;
  onChangeWidgetTypeSearchOption: (widgetType: string) => void;
}

const WidgetAllListSearchBox = (props: WidgetAllListSearchBoxProps): JSX.Element => {
  const dispatch = useDispatch();
  const { onClear, searchOption, getList, onChangeWidgetTypeSearchOption } = props;
  const { widgetType, layoutType, searchKeyword, exposurePeriod, createDate } = searchOption;

  const handleChangeLayoutType = (layoutType: number): void => {
    dispatch(widgetActions.setSearchOptionWidgetLayoutType(layoutType));
  };

  const handleChangeSearchKeywordType = (keywordType: ValueOf<typeof WIDGET_SEARCH_KEYWORD_TYPE>): void => {
    dispatch(widgetActions.setSearchOptionWidgetKeywordType(keywordType));
  };

  const handleChangeSearchKeyword = (keyword: string): void => {
    dispatch(widgetActions.setSearchOptionWidgetKeyword(keyword));
  };

  const handleChangeExposurePeriodType = (periodType: ValueOf<typeof WIDGET_EXPOSURE_TYPE>): void => {
    dispatch(widgetActions.setSearchOptionWidgetExposurePeriodType(periodType));
  };

  const handleChangeExposurePeriod = (period: { startDate: string | null; endDate: string | null }): void => {
    dispatch(widgetActions.setSearchOptionWidgetExposurePeriod(period));
  };

  const handleChangeCreateDate = (createDate: string): void => {
    dispatch(widgetActions.setSearchOptionWidgetCreateDate(createDate));
  };

  return (
    <SearchBox
      className="widget-all-list-search-box"
      onSearch={(): void => {
        getList({
          searchOption,
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={onClear}
    >
      {/*위젯 타입*/}
      <BaseForm
        label="위젯 타입"
        content={
          <Select
            className="widget-type-select"
            list={addAllItemToSelectList(WIDGET_TYPE_SELECT_LIST)}
            onChange={onChangeWidgetTypeSearchOption}
            defaultValue={widgetType}
            value={widgetType}
            isTable={false}
          />
        }
      />

      {/*위젯 레이아웃 타입*/}
      {!isNull(widgetType) ? (
        <BaseForm
          label="위젯 레이아웃 타입"
          content={
            <Select
              className="widget-layout-type-select"
              list={addAllItemToSelectList(WIDGET_LAYOUT_TYPE_SELECT_LIST[widgetType])}
              onChange={handleChangeLayoutType}
              defaultValue={layoutType}
              value={layoutType}
              isTable={false}
            />
          }
        />
      ) : null}

      {/*위젯 키워드 검색*/}
      <BaseForm
        label={
          <Select
            className="widget-keyword-search-type-select"
            list={WIDGET_SEARCH_KEYWORD_TYPE_SELECT_LIST}
            onChange={handleChangeSearchKeywordType}
            defaultValue={searchKeyword.type}
            value={searchKeyword.type}
            isTable={true}
          />
        }
        content={
          <Input value={searchKeyword.text || ''} onChange={handleChangeSearchKeyword} maxLength={30} size="large" />
        }
      />

      {/*위젯 노출기간*/}
      <BaseForm
        label="위젯 노출기간"
        className="widget-exposure-type-select-form"
        content={
          <Fragment>
            <RadioGroup
              value={exposurePeriod.type}
              list={WIDGET_EXPOSURE_SEARCH_TYPE_SELECT_LIST}
              onChange={handleChangeExposurePeriodType}
              size="large"
            />

            {exposurePeriod.type === WIDGET_EXPOSURE_TYPE.DIRECT_SETTING ? (
              <DateRangePicker
                value={exposurePeriod.period}
                showTime={true}
                outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
                startText={PLACEHOLDER_TEXT_WIDGET_EXPOSURE_PERIOD_DATE}
                endText={PLACEHOLDER_TEXT_WIDGET_EXPOSURE_PERIOD_DATE}
                btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
                format={DATE_FORMAT.FULL_DASH_FORMAT}
                onSelect={handleChangeExposurePeriod}
              />
            ) : null}
          </Fragment>
        }
      />

      {/*위젯 생성일*/}
      <BaseForm
        label="위젯 생성일"
        content={
          <DateRangePicker
            value={createDate}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={handleChangeCreateDate}
          />
        }
      />
    </SearchBox>
  );
};

export default WidgetAllListSearchBox;
